import { Button, Container, Grid, Paper, Stack, Typography, Box } from '@mui/material';
import { FormProvider, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom';

const validationSchema = Yup.object().shape({
  from_date: Yup.string().required('From date is required'),
  to_date: Yup.string().required('To date is required')
});

const defaultValues = {
  from_date: new Date().toISOString().split('T')[0],
  to_date: new Date().toISOString().split('T')[0]
};

export const PhysiotherapyBookingReport = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues,
    mode: 'all'
  });
  const { watch } = methods;

  return (
    <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none', width: '100%', height: 'auto' }}>
      <Container
        sx={{
          mt: 1,
          border: '0px solid',
          borderColor: 'grey.300',
          borderRadius: 1,
          width: '100%',
          maxWidth: 'none',
          minWidth: '100%',
          boxSizing: 'border-box'
        }}
      >
        <FormProvider methods={methods}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            sx={{ mb: 1, borderBottom: '0px solid', borderColor: 'grey.300' }}
          >
            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
              Physiotherapy Booking Report
            </Typography>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
              <Button
                variant="contained"
                id={`${lastPathSegment}Print`}
                disabled={!watch('from_date') || !watch('to_date')}
                onClick={() =>
                  window.open(
                    `/print${pathname}?refId=${JSON.stringify({
                      from_date: watch('from_date'),
                      to_date: watch('to_date')
                    })}`,
                    '_blank'
                  )
                }
              >
                View PDF Report
              </Button>
              <Button variant="contained" onClick={() => methods.reset(defaultValues)}>
                Exit
              </Button>
            </Stack>
          </Stack>

          <Box
            sx={{
              border: '0px solid gray',
              padding: 2,
              borderRadius: '8px',
              width: '60%',
              boxShadow: '0px 2px 10px #0099ff'
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={10} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </FormProvider>
      </Container>
    </Paper>
  );
};
